import { makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { ChangeEventHandler } from 'react';

type TextFieldStyledProps = {
  id: string;
  name: string;
  label: string;
  type: string | undefined;
  helperText: string | undefined;
  error: boolean | undefined;
  variant: 'filled' | 'standard' | 'outlined' | undefined;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  value?: string;
  marginBottom?: string;
  shrink?: boolean;
};

type StyleProps = {
  marginBottom: string | undefined;
  shrink: boolean | undefined;
};

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  textField: {
    marginBottom: (props) => props.marginBottom || '25px',
  },
  input: {
    fontWeight: 500,
    fontSize: '15px',
    color: theme.palette.text.secondary,
    height: '47px',
    // TODO border doesn't work..
    borderColor: '#979797',
    borderWidth: '2px !important',
  },
}));

export const TextFieldStyled: React.FC<TextFieldStyledProps> = ({
  id,
  name,
  label,
  type,
  helperText,
  error,
  variant,
  onChange,
  value,
  marginBottom,
  shrink = true,
}) => {
  const classes = useStyles({ marginBottom, shrink });
  return (
    <TextField
      className={classes.textField}
      InputProps={{
        className: classes.input,
      }}
      InputLabelProps={{ shrink }}
      id={id}
      name={name}
      label={label}
      type={type}
      helperText={helperText}
      error={error}
      variant={variant}
      onChange={onChange}
      value={value}
    />
  );
};
